<template>
  <div>
    <div style="font-size:16px;line-height:30px">
      <div style="padding-bottom:20px">
        <p style="font-weight:bold">晟铂易帆仕文化传媒（上海）有限公司为展览会指定会务接待服务商。</p>
        <p>展览会期间的酒店住宿，请直接联系晟铂易帆仕文化传媒（上海）有限公司预订。</p>
      </div>

      <div>
        <p>联系方式：</p>
        <p>禹亮：13601809725 陆琴：13918716997 </p>
        <p>电话：0086-21-64387722 </p>
        <p>地址：上海诸光路1588弄虹桥世界中心B栋252室</p>
        <p>邮箱：info@sbecm.com.cn, cac@sbecm.com.cn</p>
        <p>网址：www.sbecm.com.cn</p>
      </div>
    </div>
    <div><el-button type="primary" :style="buttonStyle" @click="downfile" >
      <a href="https://www.sbecm.com.cn/conference/show?id=conference_4VJzvhK" target="_bank" style="font-size:14px;color:#fff;text-decoration:none;" >点击查看详情</a>
      <!-- 点击查看详情 -->
      </el-button>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import tools from '../../utils/tools.js';
export default {
  data: () => ({
      buttonStyle: sessionStorage.getItem('buttonStyle') ? JSON.parse(sessionStorage.getItem('buttonStyle')) : {},
      demoExcel:'./酒店预订介绍.pdf'
  }),

  components: {},
  mounted() {

  },
  methods: {
    downfile(){

    },


  }
}
</script>
<style lang="less">


</style>

